///
/// EarthBrowser
///
/// Migration: v19 to v20 - Add GitHub OAuth support
///
/// Created by Matt Giger on December 27, 2025
/// Copyright (c) 2025 Geodata Labs
///

interface GitConfigV19 {
	remotes?: Record<string, unknown>
	githubConnected?: boolean
	defaultRemote?: string | null
	credentials?: Record<string, unknown>
	autoFetch?: boolean
	autoFetchInterval?: number
	lastFetch?: Record<string, unknown>
	lastPush?: Record<string, unknown>
}

interface StateV19 {
	gitConfig?: GitConfigV19
}

/**
 * Migration from v19 to v20
 *
 * Changes:
 * - Add githubConnected field to gitConfig
 * - Set default remote to origin with GeodataLabs/eb_scripts.git
 */
export function migrateV19toV20(state: unknown): unknown {
	if (!state) return state

	const DEFAULT_REPO_URL = 'https://github.com/GeodataLabs/eb_scripts.git'

	const s = state as StateV19

	// Get existing gitConfig or create new one
	const existingGitConfig = s.gitConfig || {}

	// Check if remotes already exist and have a configured origin
	const existingRemotes = existingGitConfig.remotes || {}
	const hasConfiguredRemote = Object.keys(existingRemotes).length > 0

	return {
		...s,
		gitConfig: {
			...existingGitConfig,
			// Add default remote if none configured
			remotes: hasConfiguredRemote ? existingRemotes : {
				origin: {
					name: 'origin',
					url: DEFAULT_REPO_URL
				}
			},
			// Add githubConnected field
			githubConnected: existingGitConfig.githubConnected ?? false,
			// Set default remote to origin if not set
			defaultRemote: existingGitConfig.defaultRemote ?? 'origin',
			// Keep other fields or use defaults
			credentials: existingGitConfig.credentials || {},
			autoFetch: existingGitConfig.autoFetch ?? false,
			autoFetchInterval: existingGitConfig.autoFetchInterval ?? 15,
			lastFetch: existingGitConfig.lastFetch || {},
			lastPush: existingGitConfig.lastPush || {}
		}
	}
}
